import {Injectable} from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import {Observable} from 'rxjs';
import {LoggerService} from '../utils/logger.service';

@Injectable()
export class HttpConsoleInterceptor implements HttpInterceptor {

  constructor(
    private logger: LoggerService
  ) {
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    this.logger.debug('requisição ', request);
    return next.handle(request);
  }
}
